import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { State } from '@app/core/ngrx/reducers';
import { authSelectors, userSelectors } from '@app/core/ngrx/selectors';
import { ProgramService } from '@app/core/services/program/program.service';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { faMapMarkerAlt } from '@fortawesome/pro-solid-svg-icons';
import { select, Store } from '@ngrx/store';
import { NavController, MenuController, ModalController } from '@ionic/angular';
import { ProgramSelectionComponent } from '@app/shared/components/program-selection/program-selection.component';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ImgPipe } from '@app/shared/pipes/img/img.pipe';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PipesComponentsModule } from '@app/shared/pipes/pipes.modules';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-program-bundle-cards',
    templateUrl: './program-bundle-cards.component.html',
    styleUrls: ['./program-bundle-cards.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, ImgPipe, FontAwesomeModule, PipesComponentsModule, RouterModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProgramBundleCardsComponent implements OnInit, OnChanges {
    @Input() program: any;
    @Input() user: any;
    programBundleForm: any;
    @Input() selected: any;
    @Input() index: number;

    userEmail: any;

    // custom way for form group validation for parent component
    @Output() formInvalidMarker = new EventEmitter<any>();

    @Output() private onFormGroupChange = new EventEmitter<any>();

    public innerWidth: any;

    selectionMode = ''; // ionic doesn't allow control for alert style ion select, set to empty string trick it

    priceDropPrice: any;
    hidePrices$ = this.store.select(userSelectors.hideProgramPrices);

    isAuthenticated$ = this.store.pipe(select(authSelectors.isAuthenticated));

    icons: any = {
        arrow: faChevronRight,
        pin: faMapMarkerAlt,
    };

    types = [];

    rows: any[] = [];
    noAvail = false;
    programType: string;
    programTime: any;

    programNotAvail: boolean = false;

    selectOptions: any = {
        cssClass: 'time-selection',
    };

    checkedDisabled: boolean = false;

    constructor(private store: Store<State>, private programService: ProgramService, private formBuilder: FormBuilder, private modalCtrl: ModalController) {
        // console.log(this.userEmail);
        this.programService.getUserEmailSubject().subscribe((USER_EMAIL) => {
            this.userEmail = USER_EMAIL;
        });
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        // use  popovers for desktop
        // this.innerWidth = window.innerWidth;
        // if (this.innerWidth < 992) {
        //     this.selectionMode = '';
        // } else {
        //     this.selectionMode = 'popover';
        // }
    }

    ngOnInit() {
        // console.log(this.userEmail);

        //  use popovers for desktop
        // this.innerWidth = window.innerWidth;
        // if (this.innerWidth < 992) {
        //     this.selectionMode = '';
        // } else {
        //     this.selectionMode = 'popover';
        // }
        this.programBundleForm = this.formBuilder.group({
            selected: new FormControl(true, Validators.compose([Validators.required])),
            type: new FormControl('', Validators.compose([Validators.required])),
            start: new FormControl('', Validators.compose([Validators.required])),
            userid: new FormControl(''),
            useremail: new FormControl(''),
            fullname: new FormControl(''),
            status: new FormControl(''),
            name: new FormControl(''),
            city: new FormControl(''),
            state: new FormControl(''),
            programid: new FormControl('', Validators.compose([Validators.required])),
            month: new FormControl(''),
            startyear: new FormControl(''),
            startdate: new FormControl(''),
        });
        this.setUpProgramForm();
    }

    ngOnChanges() {
        this.setUpProgramForm();
        this.isAuthenticated$.subscribe((isAuthenticated: boolean) => {
            if (isAuthenticated === true) {
                this.programService.availableDates(this.program.id).subscribe((response: any) => {
                    if (response) {
                        this.rows = response.map((date: any) => {
                            if (date.available === 1) {
                                return {
                                    display:
                                        date.startdate.replace('-', ' ') +
                                        ' to ' +
                                        date.enddate.replace('-', ' ') +
                                        ' — 1 Seat available. — $' +
                                        date.price +
                                        '.00 USD',
                                    value: date.selection,
                                    price: date.price,
                                    startdate: date.startdate,
                                    enddate: date.enddate,
                                    session: date.session,
                                    available: date.available,
                                };
                            } else {
                                return {
                                    display:
                                        date.startdate.replace('-', ' ') +
                                        ' to ' +
                                        date.enddate.replace('-', ' ') +
                                        ' — ' +
                                        date.available +
                                        ' Seats available — $' +
                                        date.price +
                                        '.00 USD',
                                    value: date.selection,
                                    price: date.price,
                                    startdate: date.startdate,
                                    enddate: date.enddate,
                                    session: date.session,
                                    available: date.available,
                                };
                            }
                        });
                        this.types = this.program.type.split(',');
                        if (this.rows.length === 0) {
                            this.noAvail = true;
                        }
                    }
                });
            }
        });
    }

    setUpProgramForm() {
        if (this.program && this.programBundleForm) {
            this.types = this.program.type.split(',');

            this.priceDropPrice = this.program.priceDropPrice;

            this.checkUserStatus();

            this.programBundleForm.patchValue({
                programid: this.program.id,
                name: this.program.name,
                city: this.program.city,
                state: this.program.state,
                type: this.types.length <= 1 ? this.types[0] : '',
                selected: this.programNotAvail ? false : true,
            });
        }
    }

    changeToForm(ev: CustomEvent) {
        if (ev.detail && ev.detail.hasOwnProperty('value')) {
            this.checkedDisabled = ev.detail.value ? false : true;
            if (this.checkedDisabled) {
                this.programBundleForm.controls['start'].reset();
                if (this.types.length > 1) {
                    this.programBundleForm.controls['type'].reset();
                }
            }
        }

        // check if form is valid else we emit a event to say the form is invalid and inform the user
        if (this.programBundleForm.valid) {
            this.onFormGroupChange.emit(this.programBundleForm.value);
            this.formInvalidMarker.emit({
                programid: this.programBundleForm.value.programid,
                valid: true,
                selected: this.programBundleForm.value.selected,
            });
        } else {
            this.formInvalidMarker.emit({
                programid: this.programBundleForm.value.programid,
                valid: false,
                selected: this.programBundleForm.value.selected,
            });
        }
    }

    openDetails(ev: MouseEvent) {
        this.programService.setSelectedProgramBundleIdSubject.next(this.program.id);

        setTimeout(() => {
            if (window.innerWidth < 992) {
                this.programService.setModalProgramBundleSubject.next(true);
            } else {
                this.programService.setScrollProgramBundleSubject.next(true);
            }
        }, 200);
    }

    checkUserStatus() {
        const preMedList = ['Pre-Med Online Telehealth Shadowing', 'Pre-Med Shadowing', 'Virtual Pre-Med Shadowing'];

        if (this.user.fieldofstudy === 'Physical Therapy' && this.program.specialty !== 'Physical Therapy') {
            this.programNotAvail = true;
        } else if (this.program.permitted === 'Student' && this.user.status === 'Graduate') {
            this.programNotAvail = true;
        } else if (this.program.permitted === 'Graduate' && this.user.status === 'Student') {
            this.programNotAvail = true;
        } else if (this.types.length === 1 && this.types[0] === 'Hands-On' && this.user.status === 'Graduate' && this.user.usmle === false) {
            this.programNotAvail = true;
        } else if (this.types.length === 1 && this.types[0].indexOf(preMedList) !== -1) {
            if (this.user.status === 'Pre-Med' && this.user.fieldofstudy === 'Nursing') {
                this.programNotAvail = true;
            }
        } else if (this.user.status === 'Pre-Med' && this.types.length === 1 && this.types[0].indexOf(preMedList) !== -1) {
            if (this.user.fieldofstudy === 'Nursing' && this.types[0] !== 'Nursing') {
                this.programNotAvail = true;
            }
        } else if (this.user.fieldofstudy !== 'Nursing' && this.types.length === 1 && this.types[0] === 'Nursing') {
            this.programNotAvail = true;
        } else if (this.user.fieldofstudy === 'Nursing' && this.types.length === 1 && this.types[0] !== 'Nursing') {
            this.programNotAvail = true;
        } else if (this.user.fieldofstudy !== 'Dentistry' && this.types.length === 1 && this.types[0] === 'Dentistry') {
            this.programNotAvail = true;
        } else if (this.user.fieldofstudy === 'Dentistry' && this.types.length === 1 && this.types[0] !== 'Dentistry') {
            this.programNotAvail = true;
        } else if (this.user.fieldofstudy !== 'Dentistry' && this.program.specialty === 'Dentistry') {
            this.programNotAvail = true;
        } else if (this.user.fieldofstudy !== 'Physical Therapy' && this.program.specialty === 'Physical Therapy') {
            this.programNotAvail = true;
        }
    }

    async openProgramModal(val) {
        if (val == 'type') {
            const proSeleModal = await this.modalCtrl.create({
                component: ProgramSelectionComponent,
                backdropDismiss: true,
                cssClass: 'program-notify-popup',
                componentProps: {
                    data: this.types,
                },
            });

            proSeleModal.onDidDismiss().then((data) => {
                if (data && data.data) {
                    this.programType = data.data.programType; // Here's your selected user!
                }
            });
            // then((data) => {

            //
            //
            await proSeleModal.present();
            return { success: false };
            //
        } else if (val == 'time') {
            console.log('getting time', this.rows);

            const proSeleModal = await this.modalCtrl.create({
                component: ProgramSelectionComponent,
                backdropDismiss: true,
                cssClass: 'program-notify-popup',
                componentProps: {
                    rowData: this.rows,
                    userEmail: this.userEmail,
                },
            });

            proSeleModal.onDidDismiss().then((data) => {
                if (data && data.data) {
                    this.programTime = data.data.parentRowData; // Here's your selected user!
                }
            });
            // then((data) => {

            await proSeleModal.present();
            return { success: false };
        }
    }
}
